export const workTypes = [
  { id: 'work', title: 'Часы' },
  { id: 'vacation', title: 'Отпуск' },
  { id: 'sick', title: 'Больничный' },
  { id: 'dayoff', title: 'Отгул' },
];
